import React from "react";
import SubmittedCopyright from "../sumitted_copyright/SubmittedCopyright";

const ReconsiderationRecordedCopyright = () => {
  const fileStatus = 34;
  const applicationPath = {
    copyright: "/admin/reconsideration-recorded-copyright",
    agreement: "/admin/reconsideration-recorded-agreement",
  };
  return (
    <SubmittedCopyright
      pageTitle={"নথিজাত পুনর্বিবেচনা"}
      fileStatus={fileStatus}
      applicationPath={applicationPath}
      detailsRoute={"/admin/reconsideration-copyright-details"}
    />
  );
};

export default ReconsiderationRecordedCopyright;
